module.exports = __webpack_public_path__ + "static/nilupak-ec1f62fc7643f2bce687ae135c7dc16e.jpg";